export class PasswordRoutes
{
    static Home: string = "/";
 
    // entry
    static EntryList: string = "/entry/list";
    static EntryNew: string = "/entry/new";
    static EntryView(id: string)
    {
        return `/entry/${id}/view`;
    }
    static EntryEdit(id: string)
    {
        return `/entry/${id}/edit`;
    }
    static EntryCopy(id: string)
    {
        return `/entry/${id}/copy`;
    }
   
    // template
    static TemplateList: string = "/template/list";
    static TemplateNew: string = "/template/new";
    static TemplateView(id: string)
    {
        return `/template/${id}/view`;
    }
    static TemplateEdit(id: string)
    {
        return `/template/${id}/edit`;
    }
    static TemplateCopy(id: string)
    {
        return `/template/${id}/copy`;
    }
 
    // password
    static PasswordChange: string = "/password/change";
    static PasswordRecovery: string = "/password/recovery";
    static PasswordGenerate: string = "/password/generate";
     
    // questions
    static QuestionsChange: string = "/questions/change";

    // import
    static Import: string = "/import";
}